import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/api/client";

export default function ResetPassword() {
    const [sp] = useSearchParams();
    const token = sp.get("token") || "";
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setErr(""); setMsg("");
        if (pw !== pw2) { setErr("Passwords do not match"); return; }
        try {
            await api.post("/auth/reset-password", { token, password: pw });
            setMsg("Password reset. Redirecting to log in…");
            setTimeout(() => nav("/login"), 1500);
        } catch (e) {
            setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
        }
    };

    return (
        <div className="min-h-screen bg-stone-50 flex items-center justify-center p-6" data-testid="reset-page">
            <div className="w-full max-w-md">
                <div className="relative bg-white border border-stone-200 rounded-[10px] overflow-hidden p-8 md:p-10">
                    <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-amber-500" />
                    <h2 className="text-2xl font-heading font-semibold text-stone-900 mb-1">Reset password</h2>
                    <p className="text-sm text-stone-500 mb-6">Choose a new password for your account.</p>
                    <form onSubmit={submit} className="space-y-4">
                        <input data-testid="reset-pw" type="password" required minLength={6} value={pw}
                               onChange={(e) => setPw(e.target.value)} placeholder="New password"
                               className="w-full border border-stone-300 rounded-md text-sm py-2.5 px-3 focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500" />
                        <input data-testid="reset-pw2" type="password" required minLength={6} value={pw2}
                               onChange={(e) => setPw2(e.target.value)} placeholder="Confirm password"
                               className="w-full border border-stone-300 rounded-md text-sm py-2.5 px-3 focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500" />
                        {msg && <div className="text-sm text-green-700 bg-green-50 border border-green-200 rounded-md px-3 py-2">{msg}</div>}
                        {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">{err}</div>}
                        <button data-testid="reset-submit"
                                className="w-full bg-amber-500 hover:bg-amber-600 text-white rounded-md py-2.5 font-medium">
                            Reset password
                        </button>
                    </form>
                    <div className="mt-6 text-center">
                        <Link to="/login" className="text-sm text-amber-700 hover:text-amber-900">Back to log in</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
